import { QuestionsService } from '@APP/services/questions-service';
import { css, html } from 'lit';
import { customElement, state } from 'lit/decorators';
import { Events } from '../../events/app-events';
import { DepInjMixin, requires } from '../../mixins/dependency';
import { UserService } from '../../services/user-service';
import { commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { eventBus } from '../../utils/event-bus';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { GoodMessage } from '../icons/icons';

type Deps = {
  userService: UserService;
  questionsService: QuestionsService;
};

@requires(UserService.serviceName, QuestionsService.serviceName)


@customElement('welcome-existing-user-popup')
export class WelcomePopup extends DepInjMixin<Deps>(DeviceAwareComponent) {
  static get baseStyles() {
    return [
      commonPopupStyle,
      css`
        .title {
          font-weight: 700;
          font-size: 4rem;
      margin-bottom:4.75rem;
    }
     .message {
        font-weight: 400;
        max-width:var(--message-max-width, 39rem);
        color: var(--c-text);
    }

      h2:last-of-type{
      margin-bottom: 2rem;
    }
    `,
    ];
  };

  static get mobileStyles() {
    return [commonPopupMobileStyle];
  }

  private unsubs: Function[] = [];

  @state()
    username: string = '';

  connectedCallback() {
    super.connectedCallback();

    this.unsubs.push(
      eventBus().on<void>(
        Events.Type.Refresh,
        this.checkLoginState.bind(this),
      ),
    );
    this.checkLoginState();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubs.forEach((f) => f());
  }


  private checkLoginState() {
    this.username = this.deps.userService.getNameTitle();
  }

  renderMobileLayout() {
    return html`
      <div class="grid-container">
       <div class="col-1">
         <h1 class="title">${this.username ? t('T_Welcome_Back_Message', this.username) : t('Welcome back!')}</h1>
       </div>
       <div class="col-2">
        ${GoodMessage}
      </div>
      <div class="col-3">
        <h2 class="message">${t('T_Welcome_Back_Tagline1')} ${t('T_Welcome_Back_Tagline2')} ${t('T_Welcome_Back_Tagline3')}</h2>
      </div>
     </div>
    `;
  }

  renderDesktopLayout() {
    return html`
     <div class="grid-container">
       <div class="col-1"></div>
       <div class="col-2">
        <h1 class="title">${this.username ? t('T_Welcome_Back_Message', this.username) : t('Welcome back!')}</h1>
        <h2 class="message">${t('T_Welcome_Back_Tagline1')}</h2>
        <h2 class="message">${t('T_Welcome_Back_Tagline2')}</h2>
        <h2 class="message">${t('T_Welcome_Back_Tagline3')}</h2>
      </div>
     </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
